import { Badge } from '@mantine/core';
import React from 'react';

import { useI18n } from '../../contexts/I18nProvider';
import { NO_WORK_UNIT } from '../../variables/GlobalVariables';

type Props = {
  unit?: string;
};

export default function UnitBadge({ unit }: Props) {
  const { t } = useI18n();

  return (
    <Badge
      styles={{
        root: { textTransform: 'none' },
        label: { color: '#ebf2ff' },
      }}
      color="#647fcc"
    >
      {unit === NO_WORK_UNIT ? t(`NO_WORK_UNIT`) : unit}
    </Badge>
  );
}
